/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Make Nevermore hero videos clickable
  function makeNevermoreHeroClickable() {
    const heroSections = [
      'template--27909137170509__section_video_rHLadH',
      'template--27909137170509__section_video_GTNHAF'
    ];

    heroSections.forEach(function(id) {
      const section = document.getElementById('shopify-section-' + id);

      if (!section || section.dataset.clickableHero === 'true') return;

      section.dataset.clickableHero = 'true';
      section.style.cursor = 'pointer';

      section.addEventListener('click', function(event) {
        if (event.target.closest('a, button, input, select, textarea')) return;

        window.location.href = '/collections/nevermore';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', makeNevermoreHeroClickable);
  } else {
    makeNevermoreHeroClickable();
  }

  document.addEventListener('shopify:section:load', makeNevermoreHeroClickable);





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
